import {
  isString,
  isNumber,
  isBoolean,
  isNull,
} from '../../../helper/index.js';
import {
  sha256
} from '../../../algo/hash/index.js';

const normalizeData = (data) => {
  if (data.type === 'atom') {
    const value = data.value;
    if (isNumber(value)) {
      return `00${value}`;
    }
    if (isBoolean(value)) {
      return `01${value}`;
    }
    if (isNull(value)) {
      return `02${value}`;
    }
    if (isString(value)) {
      return `03${value}`;
    }

    return `04${value}`;
  } else if (data.type === 'array') {
    return '1';
  } else { // object
    return '2';
  }
};

export default (data, childHashs) => {
  const str = normalizeData(data) + childHashs.join(',');
  return sha256(str);
};
